import { useTranslation } from "react-i18next";
import { NeuButton, NeuCard } from "../../components/neu/Neu";

// نافذة تأكيد عامة: نعم (أحمر) / لا.
export const ConfirmDialog = ({ open, title, body, confirmLabel, cancelLabel, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-background/80 p-4"
         data-testid="penalty-confirm-dialog" onClick={onCancel}>
      <NeuCard className="grid w-full max-w-md gap-4" onClick={(e) => e.stopPropagation()}>
        <h3 className="text-lg font-black text-destructive">{title}</h3>
        {body ? <p className="text-sm text-muted-foreground">{body}</p> : null}
        <div className="flex flex-wrap gap-3">
          <NeuButton className="bg-destructive px-5 py-3 text-destructive-foreground hover:brightness-110"
                     data-testid="penalty-confirm-yes" onClick={onConfirm}>
            {confirmLabel || t("penalty.confirm.yes")}
          </NeuButton>
          <NeuButton data-testid="penalty-confirm-no" onClick={onCancel}>
            {cancelLabel || t("penalty.confirm.no")}
          </NeuButton>
        </div>
      </NeuCard>
    </div>
  );
};
